import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTracker = () => {
  const loc = useLocation();

  useEffect(() => {
    const page_title = (() => {

      const pageTitle = {
        "alert-cms": "Alert CMS",
        "custom-query": "Custom Query",
        "log-parsing": "Log Parsing",
        "user-spoofing": "User Spoofing",
        "unauthorized": "ProactivePortal",
        "ProactivePortal": "ProactivePortal"
      };

      let pathArr = loc.pathname.split("/");
      if (pathArr[1] === '') {
        if (document.title != "ProactivePortal") {
          document.title = "ProactivePortal"
        }
        return document.title;
      } else if (pathArr.length > 1) {
        if (pathArr[1] in pageTitle) {
          document.title = pageTitle[pathArr[1]];
          return document.title;
        } else {
          if (pathArr[1].toLowerCase() == "account") {
            if (pathArr[2] && pathArr[2] !== '') {
              document.title = "Account " + pathArr[2];
            } else {
              document.title = "Account";
            }
          } else if (pathArr[1].toLowerCase() == "instrument") {
            if (pathArr[2] && pathArr[2] !== '') {
              document.title = "Instrument " + pathArr[2];
            } else {
                document.title = "Instrument";
            }
          } else if (pathArr[1].toLowerCase() == "run") {
            if (pathArr[2] && pathArr[2] === 'ipsRunId') {
              if (pathArr[3] && pathArr[3] !== '') {
                document.title = "Run " + pathArr[3];
              } else {
                  document.title = "Run";
              }
            } else if (pathArr[2] && pathArr[2] !== '') {
              document.title = "Run " + pathArr[2];
            } else {
              document.title = "Run";
            }
          }
          return document.title;
        }
      } else {
        if (document.title != "ProactivePortal") {
          document.title = "ProactivePortal"
        }
        return document.title;
      }

    })();
    if ("gtag" in window) {
      window.gtag("event", "proactive_page_view", {
        page_title,
        page_location: window.location.href,
        page_path: window.location.pathname,
      });
    }
  }, [loc]);

  return <p style={{ display: "none" }}>.</p>;
};

export default PageTracker;
